import React from "react";
import { Flex } from "rebass";

import DynamicButton, { mediumNavListButtonSettings } from "../../shared/components/dynamic-button/dynamic-button";
import { FooterColumnContent, FooterContactList, FooterLinkContent, IconPack } from "../../shared/models/app-data-model";
import "./global-flat-footer-column.scss";

export type GlobalFlatFooterColumnProps = {
  content: FooterColumnContent;
  iconPack: IconPack[];
};

const GlobalFlatFooterColumn: React.FC<GlobalFlatFooterColumnProps> = ({ content, iconPack }: GlobalFlatFooterColumnProps) => {
  const rendering = content?.footer_blocks?.map((item, index) => {
    return (
      <>
        {item?.heading?.heading && <span className="column-label">{item?.heading?.heading}</span>}
        {item?.link_list && (
          <Flex className="content-container">
            <ul className="flat-footer-link-list">
              {item?.link_list?.links?.map((link: FooterLinkContent, index) => {
                return (
                  <>
                    {link?.display_text && link?.reference && (
                      <li>
                        <DynamicButton
                          content={{
                            text: `${link?.display_text}`,
                            icon: `${link?.new_window_icon ? "new_window" : "none"}`,
                            reference: link?.reference,
                            settings: mediumNavListButtonSettings
                          }}
                          iconPack={iconPack}
                          key={index}
                        />
                      </li>
                    )}
                  </>
                );
              })}
            </ul>
          </Flex>
        )}
        {item?.contact && (
          <Flex className="content-container">
            {item.contact?.contact_list?.map((contact: FooterContactList, index) => {
              return (
                <>
                  <Flex className="contact" key={index}>
                    {contact.heading && <span className="heading">{contact.heading}</span>}
                    {contact.subheading && <span className="subheading">{contact.subheading}</span>}
                    {contact.phone_link && contact.phone_display_text && (
                      <DynamicButton
                        content={{
                          text: `${contact.phone_display_text}`,
                          icon: "none",
                          reference: contact.phone_link,
                          settings: mediumNavListButtonSettings
                        }}
                        cssClasses={"phone-number"}
                        iconPack={iconPack}
                      />
                    )}
                  </Flex>
                </>
              );
            })}
          </Flex>
        )}
        {item?.content_block?.content && (
          <Flex className="content-container">
            <div className="rich-text" dangerouslySetInnerHTML={{ __html: item.content_block.content }}></div>
          </Flex>
        )}
        {item?.footer_cta_button && (
          <div className="content-container footer-cta-button">
            <DynamicButton content={item?.footer_cta_button} iconPack={iconPack} />
          </div>
        )}
      </>
    );
  });

  return <Flex className="footer-column">{rendering}</Flex>;
};

export default GlobalFlatFooterColumn;
